import { EventBus } from '@adeo/kobi--front-helpers';
import { getAutoContextualisationSelector, onUserConsentChange } from "../autocontextualization/autocontextualization.src";
import { autoContextUserFromStoreIdAndPostCode } from "../autocontextualization/services/auto-context-service";
import { retrieveCookieValueByName, retrieveCustomerContextCookieValue } from "./cookie-finder";
export const STORE_HEADER_MODULE_EVENT_BUS_NAME = "store-module-header-event-bus";
export const OPENING_STORE_CHOICES_MODAL_EVENT = "autocontext:choicestore:openmodal";
export const SET_STORE_EVENT = "autocontext:store:set";
export const USER_CONSENT_EVENT = "PrivacyChange";
export const USER_AUTO_CONTEXT_SUCCESS_EVENT = 'userAutoContextSuccess';
initStoreHeaderEventBus();
listenUserConsentEvent();
emitModalEventWhenNoConsentOrContext();
const eventBus = window.storeHeaderModule.eventBus;
function initStoreHeaderEventBus() {
  if (!window.storeHeaderModule) {
    window.storeHeaderModule = {};
  }
  if (!window.storeHeaderModule.eventBus) {
    window.storeHeaderModule.eventBus = new EventBus(STORE_HEADER_MODULE_EVENT_BUS_NAME);
  }
}
function listenUserConsentEvent() {
  const autoContextualizationSelector = getAutoContextualisationSelector();
  if (!autoContextualizationSelector) return;
  const isConsentByPassed = autoContextualizationSelector.dataset.isconsentbypassenabled === "true";
  const customerContextCookie = retrieveCustomerContextCookieValue();
  if (!customerContextCookie && !isConsentByPassed) {
    window.addEventListener(USER_CONSENT_EVENT, onUserConsentChange);
  }
}
function emitModalEventWhenNoConsentOrContext() {
  setTimeout(() => {
    const consentCookie = retrieveCookieValueByName('OptanonConsent');
    const contextCookie = retrieveCookieValueByName('customer_context');
    if (!consentCookie && !contextCookie) {
      dispatchOpeningStoreChoicesModalEvent();
    }
  }, 3000);
}
export function dispatchCustomerContextSuccessEvent() {
  const event = new CustomEvent(USER_AUTO_CONTEXT_SUCCESS_EVENT, {
    detail: {
      isUserAutoContextSuccess: true
    }
  });
  window.dispatchEvent(event);
}
export function dispatchCustomerAutoContextFailureEvent() {
  const event = new CustomEvent(USER_AUTO_CONTEXT_SUCCESS_EVENT, {
    detail: {
      isUserAutoContextSuccess: false
    }
  });
  window.dispatchEvent(event);
}
export function dispatchOpeningStoreChoicesModalEvent() {
  eventBus.emit(OPENING_STORE_CHOICES_MODAL_EVENT);
}
eventBus.on(SET_STORE_EVENT, ({
  detail
}) => {
  autoContextUserFromStoreIdAndPostCode(detail.storeId, detail.postcode);
});